export default __webpack_public_path__ + "arrow-pointing-down.png";